import { Box } from '@mui/material';

export const timestampColumnWidth = 170;

export const wrapHeader = (header: string) => (
  <Box sx={{ fontWeight: 'medium', whiteSpace: 'wrap' }}>{header}</Box>
);

export const wrapAndCenterHeader = (header: string) => (
  <Box sx={{ fontWeight: 'medium', textAlign: 'center', whiteSpace: 'wrap' }}>
    {header}
  </Box>
);
